var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "catalog-content" } },
    [
      _c("b-row", [
        _c(
          "div",
          { staticClass: "col-md-9" },
          [
            _vm.catalogForm
              ? _c(
                  "b-tabs",
                  [
                    _c("MultiContent", {
                      ref: "MultiContent",
                      model: {
                        value: _vm.catalogFormInitialObject,
                        callback: function ($$v) {
                          _vm.catalogFormInitialObject = $$v
                        },
                        expression: "catalogFormInitialObject",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a-button",
              { attrs: { type: "primary" }, on: { click: _vm.updateContent } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.update")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        !!_vm.catalogForm
          ? _c("div", { staticClass: "col-md-3 content-statistics" }, [
              _c("h4", [_vm._v("İçerik Durum İstatistiği")]),
              _vm._v(" "),
              _c("div", { staticClass: "userInfo" }, [
                _c("div", { staticClass: "userInfo first" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("message.like")) +
                      " :\n                    "
                  ),
                  _c("span", { staticClass: "userInfo sec" }, [
                    _vm._v(_vm._s(_vm.catalogForm.rate.up)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "userInfo" }, [
                  _c("div", { staticClass: "userInfo first" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("message.disLike")) +
                        " :\n                        "
                    ),
                    _c("span", { staticClass: "userInfo sec" }, [
                      _vm._v(_vm._s(_vm.catalogForm.rate.down)),
                    ]),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }